import React, { Component, useEffect } from 'react';

import { connect } from 'react-redux';
import { withStyles } from "@material-ui/core";
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Slider from '@mui/material/Slider';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import Input from '@mui/material/Input';
import FormControl from '@mui/material/FormControl';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';
import RUNIcon from '@material-ui/icons/PlayArrow';
import AWS from 'aws-sdk';
import config from '../../../../../config.json';
import { format } from 'date-fns';



//-----------------------------------------------------------------



const useStyles = (theme) => ({

});



//-----------------------------------------------------------------



class CT_Column_ extends Component {

    constructor(props) {
        super(props);
        //initailizes Variables with preset values
        this.state = {
            objectPosition: 101.616,
            sdd: null,

            xRaySourceType: null,
            photonCount: 20,
            voltageMin: 60,
            voltageMax: 100,

            orientationPhi: null,
            orientationTheta: null,
            displacementX: null,
            displacementY: null,
            displacementZ: null,
            rotationCount: 20,

            detectorType: null,
            detectorResolution: 1000,

            optionProjection: false,
            optionSinogram: false,
            optionMaterialmesh: false,
            optionQFactor: false,
            optionPablo: false,

            isHoverSource: false,
            isHoverObject: false,
            isHoverDetector: false,
            isHoverSDD: false,
            showAlertSimulationStart: false,
        };

    }


    render() {

        const { classes } = this.props;


        //-------------------------------------------------------------

        //Predefining FOV Slider position and values
        const marks_Slider_ObjectPos = [
            {
                value: 2.66,
                scaledValue: 31.0146848,
                fieldOfView: 10
            },
            {
                value: 4.3739,
                scaledValue: 51.6007796,
                fieldOfView: 16
            },
            {
                value: 6.5180,
                scaledValue: 76.6568204,
                fieldOfView: 25
            },
            {
                value: 8.662,
                scaledValue: 101.616,
                fieldOfView: 35
            },
            {
                value: 13.4648,
                scaledValue: 157.4865696,
                fieldOfView: 50
            },
            {
                value: 18.782,
                scaledValue: 219.39,
                fieldOfView: 75
            },
            {
                value: 27.36,
                scaledValue: 319.2526732,
                fieldOfView: 100
            },
            {
                value: 37.73,
                scaledValue: 440.1788814,
                fieldOfView: 150
            },
            {
                value: 50,
                scaledValue: 583.443,
                fieldOfView: 200
            },
            {
                value: 66.46,
                scaledValue: 775.044,
                fieldOfView: 250
            },
        ];

        //Calculating Object Size
        var Slider_ObjectPos_Size = Math.sqrt((this.props.stlBounds[1] - this.props.stlBounds[0]) * (this.props.stlBounds[1] - this.props.stlBounds[0]) +
            (this.props.stlBounds[3] - this.props.stlBounds[2]) * (this.props.stlBounds[3] - this.props.stlBounds[2]) +
            (this.props.stlBounds[5] - this.props.stlBounds[4]) * (this.props.stlBounds[5] - this.props.stlBounds[4]));

        Slider_ObjectPos_Size = Slider_ObjectPos_Size / 391.0464 * 142;

        //Calculating FOV
        let FoV;
        for (var i = 0; i < marks_Slider_ObjectPos.length; i++) {
            if (marks_Slider_ObjectPos[i].scaledValue <= this.state.objectPosition)
                FoV = Math.round(marks_Slider_ObjectPos[i].fieldOfView / this.state.detectorResolution * 1000) / 1000;
        }



        //-------------------------------------------------------------

        //Presetting marks for Rotationcount Slider
        const marks_Slider_RotationCounts = [
            {
                value: 0,
                scaledValue: 0,
                label: "0"
            },
            {
                value: 20,
                scaledValue: 10,
                label: "10"
            },
            {
                value: 40,
                scaledValue: 100,
                label: "100"
            },
            {
                value: 60,
                scaledValue: 1000,
                label: "1000"
            },
            {
                value: 80,
                scaledValue: 10000,
                label: "10000"
            },
        ];

        //Calculating Rotationscount Slider increments
        function rotationCount_Scale(value) {
            const previousMarkIndex = Math.floor(value / 20);
            const previousMark = marks_Slider_RotationCounts[previousMarkIndex];
            const remainder = value % 20;
            if (remainder === 0) return previousMark.scaledValue;
            const nextMark = marks_Slider_RotationCounts[previousMarkIndex + 1];
            const increment = (nextMark.scaledValue - previousMark.scaledValue) / 20;
            return Math.round(remainder * increment + previousMark.scaledValue);
        };

        function rotationCount_RevScale(value) {

            var previousMarkIndex = 0;
            for (; previousMarkIndex < marks_Slider_RotationCounts.length && value > marks_Slider_RotationCounts[previousMarkIndex].scaledValue; previousMarkIndex++);
            previousMarkIndex -= 1;

            if (previousMarkIndex < 0) previousMarkIndex = 0;
            if (previousMarkIndex == marks_Slider_RotationCounts.length - 1) return marks_Slider_RotationCounts[previousMarkIndex].value;
            if (value <= marks_Slider_RotationCounts[0].value) return marks_Slider_RotationCounts[0].value;

            const previousMark = marks_Slider_RotationCounts[previousMarkIndex];
            const nextMark = marks_Slider_RotationCounts[previousMarkIndex + 1];

            const increment = 20 * (value - previousMark.scaledValue) / (nextMark.scaledValue - previousMark.scaledValue);

            return increment + previousMark.value;

        };


        //-------------------------------------------------------------


        //Defines VoltageRange's Slider Increments, Decrements, min and max
        var marks_Slider_VoltageRange = [];

        for (var i = 0; i < 34; i++)
            if (i % 11 == 0)
                marks_Slider_VoltageRange.push({
                    value: (60 + i * 5),
                    label: (60 + i * 5) + ' kV',
                });
            else
                marks_Slider_VoltageRange.push({
                    value: (60 + i * 5),
                    label: '',
                });


        //-------------------------------------------------------------

        //Predefining Detectorresolution Slider Positions and values
        const marks_Slider_DetectorRes = [
            {
                value: 100,
                label: "100"
            },
            {
                value: 500,
                label: "500"
            },
            {
                value: 1000,
                label: "1000"
            },
            {
                value: 1500,
                label: "1500"
            },
            {
                value: 2000,
                label: "2000"
            }

        ]


        //-------------------------------------------------------------

        //Predefining Photoncount Slider Postions and Values
        const marks_Slider_PhotonCount = [
            {
                value: 0,
                scaledValue: 0,
                label: "0"
            },
            {
                value: 20,
                scaledValue: 100000,
                label: "100k"
            },
            {
                value: 40,
                scaledValue: 1000000,
                label: "1M"
            },
            {
                value: 60,
                scaledValue: 10000000,
                label: "10M"
            },
            {
                value: 80,
                scaledValue: 100000000,
                label: "100M"
            },
            {
                value: 100,
                scaledValue: 1000000000,
                label: "1B"
            },
        ];

        //Calculating Photoncount
        function photonCount_Label(num) {
            if (num < 1000000) return (num / 1000).toFixed(0) + "K";
            else if (num < 1000000000) return (num / 1000000).toFixed(0) + "M";
            else return (num / 1000000000).toFixed(0) + "B";
        }

        //Calculating Photoncount's Slider increments/steps
        function photonCount_Scale(value) {
            const previousMarkIndex = Math.floor(value / 20);
            const previousMark = marks_Slider_PhotonCount[previousMarkIndex];
            const remainder = value % 20;
            if (remainder === 0) return previousMark.scaledValue;
            const nextMark = marks_Slider_PhotonCount[previousMarkIndex + 1];
            const increment = (nextMark.scaledValue - previousMark.scaledValue) / 20;
            return Math.ceil(remainder * increment + previousMark.scaledValue);
        };

        function photonCount_RevScale(value) {

            var previousMarkIndex = 0;
            for (; previousMarkIndex < marks_Slider_PhotonCount.length && value > marks_Slider_PhotonCount[previousMarkIndex].scaledValue; previousMarkIndex++);
            previousMarkIndex -= 1;

            if (previousMarkIndex < 0) previousMarkIndex = 0;
            if (previousMarkIndex == marks_Slider_PhotonCount.length - 1) return marks_Slider_PhotonCount[previousMarkIndex].value;
            if (value <= marks_Slider_PhotonCount[0].value) return marks_Slider_PhotonCount[0].value;

            const previousMark = marks_Slider_PhotonCount[previousMarkIndex];
            const nextMark = marks_Slider_PhotonCount[previousMarkIndex + 1];

            const increment = 20 * (value - previousMark.scaledValue) / (nextMark.scaledValue - previousMark.scaledValue);

            return increment + previousMark.value;

        };


        //-------------------------------------------------------------

        //Images directory
        var CT_Image = "";
        var WZL_Logo = "url(./res/images/logo_WZL.png)";

        if (this.state.isHoverSource == true) CT_Image = "url(./res/images/ct_pos_source.png)";
        else if (this.state.isHoverSDD == true) CT_Image = "url(./res/images/ct_pos_sdd.png)";
        else if (this.state.isHoverDetector == true) CT_Image = "url(./res/images/ct_pos_detector.png)";
        //else CT_Image = "url(./res/images/ct_pos_plain.png)";
        else CT_Image = "url(" + process.env.PUBLIC_URL + "/res/images/ct_pos_plain.png)";


        //-------------------------------------------------------------

        //XRay source types
        const sourceTypes = ["W_0.006_0.5mmSn", "W_0.006_1.2mmSn", "W_0.006_1mmAl", "W_0.006_1mmCu", "W_0.006_3mmSn",
            "W_0.006_WW", "W_0.006_oF", "W_0.007_1mmSn", "W_0.009_WW", "W_R11_6mmCuZn"];



        //-------------------------------------------------------------

        //Detector types
        const detectorTypes = ["Winwerth"];


        //-------------------------------------------------------------

        //SDDs distances
        const SDDs = [1166];


        //-------------------------------------------------------------

        //Function to download JSON file
        const downloadJSON = () => {

            if (this.props.stlObjects.length == 0 ||
                this.state.sdd == null || this.state.xRaySourceType == null || this.state.orientationPhi == null || this.state.orientationTheta == null ||
                this.state.displacementX == null || this.state.displacementY == null || this.state.displacementZ == null || this.state.detectorType == null) {

                this.setState({ showAlertSimulationStart: true });
                return;

            }



            let arr_STLs = [];
            let arr_Mats = [];
            for (var i = 0; i < this.props.stlObjects.length; i++) {
                arr_STLs.push(this.props.stlObjects[i].STLFileName);
                arr_Mats.push(this.props.stlObjects[i].material);
            }

            let arr_SourceEnergies = [];
            for (var e = this.state.voltageMin; e <= this.state.voltageMax; e += 5)
                arr_SourceEnergies.push(e * 1000.0);


            let arr_Analyzer = [];
            let arr_Analyzer_Options = []

            if (this.state.optionProjection == true) {
                arr_Analyzer.push("FileWriter_MC_Projection");
                arr_Analyzer_Options.push("true,true");

                if (this.state.optionMaterialmesh == true) {
                    arr_Analyzer.push("FileWriter_Material_Projection");
                    arr_Analyzer_Options.push("true,true");
                }

            }
            if (this.state.optionSinogram == true) {
                arr_Analyzer.push("FileWriter_MC_Sinogram");
                arr_Analyzer_Options.push("true,true");

                if (this.state.optionMaterialmesh == true) {
                    arr_Analyzer.push("FileWriter_Material_Sinogram");
                    arr_Analyzer_Options.push("true,true");
                }

            }
            if (this.state.optionQFactor == true) {
                arr_Analyzer.push("QFactor");
                arr_Analyzer_Options.push("edit");
            }

            //JSON Values 
            const data = {
                "object":
                {
                    "STL-Paths": arr_STLs,
                    "Material-Types": arr_Mats,
                    "Voxel-Resolution": [0.4, 0.4, 0.4],
                    "Object-Displacement-x": [this.state.displacementX],
                    "Object-Displacement-y": [this.state.displacementY],
                    "Object-Displacement-z": [this.state.displacementZ],
                    "Object-Orientation-x": [this.state.orientationPhi / 360.0 * 2.0 * Math.PI],
                    "Object-Orientation-y": [this.state.orientationTheta / 360.0 * 2.0 * Math.PI],
                    "Object-Orientation-z": [0.0]
                },
                "source":
                {
                    "Source-Name": [this.state.xRaySourceType],
                    "Source-EnergyMax": arr_SourceEnergies,
                    "Source-Distance": [this.state.objectPosition]
                },
                "detector":
                {
                    "Detector-Distance": [this.state.sdd - this.state.objectPosition],
                    "Detector-Size": [391.0464, 391.0464],
                    "Detector-Resolution": [this.state.detectorResolution, this.state.detectorResolution]
                },
                "simulation":
                {
                    "Simulation-Rotation-Bounds": [0.0, 6.28],
                    "Simulation-Rotation-Counts": rotationCount_Scale(this.state.rotationCount),
                    "Simulation-PhotonCounts": photonCount_Scale(this.state.photonCount),
                    "Simulation-Seed": 7242
                },
                "output":
                {
                    "Output-FolderPath": "./output",
                    "Output-Settings": true,
                    "Reference-Simulation": true,
                    "Analyzer": arr_Analyzer,
                    "Analyzer-Param": arr_Analyzer_Options
                }
            };


            const now = new Date();
            const dateStr = now.toLocaleString().replace(/[/\s:]/g, '-');
            const fileName = `${dateStr}.json`;

            const json = JSON.stringify(data, null, 2);
            const blob = new Blob([json], { type: "application/json" });
            const href = URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = href;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();

            document.body.removeChild(link);
            URL.revokeObjectURL(href);

            const AWS = require('aws-sdk');

            AWS.config.update({
                accessKeyId: config.accessKeyId,
                secretAccessKey: config.secretAccessKey,
                region: config.region
            });

            const s3 = new AWS.S3();
            const params = {
                Bucket: 'testbucket-516579854',
                Key: `outgoing/${fileName}`,
                Body: json
            };

            s3.upload(params, (err, data) => {
                if (err) {
                    console.error('Error uploading file:', err);
                    return;
                }

                console.log('File uploaded successfully:', data.Location);
            });



        }


        //-------------------------------------------------------------


        return (

            <Grid //Main Grid for CT_Column
                container
                direction="column"
                justifyContent="flex-start"
                alignItems="stretch"
                spacing={0}
            //height="160vh"
            >

                <Grid //Grid for SDD Menu and WZL Logo
                    item
                    xs={1}
                    sx={{ display: "flex", flexDirection: "column" }}>

                    <Box sx={{ flexGrow: 1, marginTop: 4, marginBottom: 1 }}>

                        <Grid
                            container
                            spacing={0}
                            direction="column"
                            alignItems="center"
                            justifyContent="center"
                            style={{ width: '100%' }}
                        >

                            <Grid item xs
                                onMouseEnter={() => this.setState({ isHoverSDD: true, isHoverDetector: false, isHoverSource: false, isHoverObject: false })}
                                onMouseLeave={() => this.setState({ isHoverSDD: false, isHoverDetector: false, isHoverSource: false, isHoverObject: false })}
                                sx={{
                                    width: '100%', flexGrow: 1, display: "flex", flexDirection: "column", marginTop: 0, marginBottom: 0,
                                    backgroundSize: 'contain', backgroundRepeat: 'no-repeat', backgroundPosition: 'right',
                                    backgroundImage: WZL_Logo
                                }}
                                alignItems="center"
                                justifyContent="center">
                                <FormControl size="small" style={{ minWidth: 150, maxWidth: 150 }}>
                                    <InputLabel>SDD</InputLabel>
                                    <Select
                                        value={this.state.sdd}
                                        label="SDD"
                                        onChange={(event) => { this.setState({ sdd: event.target.value }); }}>
                                        {SDDs.map((label, index) => {
                                            return (<MenuItem value={label}>{label + " mm"}</MenuItem>); //Sets SDD value
                                        })}
                                    </Select>
                                </FormControl>
                            </Grid>

                        </Grid>

                    </Box>

                </Grid>

                <Grid item xs={4} md={4} sx={{ display: "flex", flexDirection: "column" }}>

                    <Grid //Grid For Slider with Background Image
                        container
                        spacing={0}
                        direction="column"
                        alignItems="center"
                        height="35vh"
                        justifyContent="center"
                        sx={{
                            flexGrow: 1, display: "flex", flexDirection: "column", marginTop: 5, marginBottom: 5,
                            backgroundSize: "87% auto", backgroundRepeat: 'no-repeat', backgroundPosition: 'center',
                            backgroundImage: CT_Image
                        }}
                    >

                        <Slider //Slider with preset positions
                            track={false}
                            defaultValue={marks_Slider_ObjectPos.findIndex((mark) => mark.scaledValue === this.state.objectPosition).value}
                            valueLabelFormat={(value) => { return marks_Slider_ObjectPos.findIndex((mark) => mark.value === value) + 1; }}
                            getAriaValueText={(value) => { return marks_Slider_ObjectPos.findIndex((mark) => mark.value === value).label; }}
                            step={null}
                            marks={marks_Slider_ObjectPos}
                            onChange={(event, newValue) => {
                                this.setState({ objectPosition: marks_Slider_ObjectPos[marks_Slider_ObjectPos.findIndex((mark) => mark.value === newValue)].scaledValue });
                            }}
                            sx={{
                                width: '80%', marginLeft: 3,
                                '& .MuiSlider-thumb': {
                                    height: (Slider_ObjectPos_Size <= 1.0) ? 24 : Slider_ObjectPos_Size,
                                    width: (Slider_ObjectPos_Size <= 1.0) ? 24 : 6,
                                    borderRadius: (Slider_ObjectPos_Size <= 1.0) ? 64 : 4,
                                    color: (this.state.isHoverObject == true) ? '#00549F' : '#000000'
                                },
                            }}
                        />

                    </Grid>

                </Grid>


                <Grid item xs sx={{ display: "flex", flexDirection: "column" }}>

                    <Box sx={{ flexGrow: 1, marginLeft: 2, marginRight: 2, display: "flex", flexDirection: "column", height: '100%' }}>

                        <Grid
                            container
                            direction="row"
                            spacing={1}
                            alignItems="stretch"
                            justifyContent="flex-start"
                            sx={{ height: '100%', minWidth: 450 }}>

                            <Grid //Grid Group (left): XRay, Voltage, Photoncount
                                item
                                xs={4}
                                md={4} >

                                <Paper elevation={3} sx={{ flexGrow: 1, height: '100%', minWidth: 150 }}
                                    onMouseEnter={() => this.setState({ isHoverSource: true, isHoverObject: false, isHoverDetector: false, isHoverSDD: false })}
                                    onMouseLeave={() => this.setState({ isHoverSource: false, isHoverObject: false, isHoverDetector: false, isHoverSDD: false })}>

                                    <Grid
                                        container
                                        direction="column"
                                        justifyContent="flex-start"
                                        alignItems="stretch"
                                        sx={{ height: '100%', paddingLeft: 3, paddingRight: 3 }}
                                    >

                                        <Grid //Grid for XRay Source dropdown menu 
                                            item
                                            xs={3}
                                            sx={{ display: "flex", flexDirection: "column" }}>

                                            <FormControl size="small" sx={{ height: 2, marginTop: 4 }}>
                                                <InputLabel>X-Ray source</InputLabel>
                                                <Select
                                                    value={this.state.xRaySourceType}
                                                    label="X-Ray source"
                                                    onChange={(event) => { this.setState({ xRaySourceType: event.target.value }); }}>
                                                    {sourceTypes.map((label, index) => {
                                                        return (<MenuItem value={label}>{label}</MenuItem>); //sets XRay Source 
                                                    })}
                                                </Select>
                                            </FormControl>

                                        </Grid>

                                        <Grid //Voltage Display and Slider
                                            item
                                            xs
                                            sx={{ display: "flex", flexDirection: "column", marginTop: 3 }}>

                                            <Typography //Voltage Display; pulls values from Voltage Slider
                                                variant="subtitle1"
                                                color="textPrimary"
                                                sx={{ fontWeight: 600 }}>

                                                Voltage: {this.state.voltageMin}kV to {this.state.voltageMax}kV

                                            </Typography>

                                            <Slider //Voltage Slider for voltage range
                                                sx={{ display: "flex", marginLeft: 2, marginRight: 2, marginTop: 0.4, width: "88%" }}
                                                value={[this.state.voltageMin, this.state.voltageMax]}
                                                valueLabelFormat={(value) => { return marks_Slider_VoltageRange.findIndex((mark) => mark.value === value) + 1; }}
                                                getAriaValueText={(value) => { return marks_Slider_VoltageRange.findIndex((mark) => mark.value === value).label; }}
                                                step={null}
                                                min={marks_Slider_VoltageRange[0].value}
                                                max={marks_Slider_VoltageRange[marks_Slider_VoltageRange.length - 1].value}
                                                marks={marks_Slider_VoltageRange}
                                                disableSwap
                                                onChange={(event, newValue, activeThumb) => {
                                                    if (newValue[1] - newValue[0] < 5) {
                                                        if (activeThumb === 0) {
                                                            const clamped = Math.min(newValue[0], marks_Slider_VoltageRange[marks_Slider_VoltageRange.length - 1].value - 5);
                                                            this.setState({ voltageMin: clamped });
                                                            this.setState({ voltageMax: clamped + 5 });
                                                        } else {
                                                            const clamped = Math.max(newValue[1], 5);
                                                            this.setState({ voltageMin: clamped - 5 });
                                                            this.setState({ voltageMax: clamped });
                                                        }
                                                    } else {
                                                        this.setState({ voltageMin: newValue[0] });
                                                        this.setState({ voltageMax: newValue[1] });
                                                    }
                                                }}
                                            />

                                        </Grid>

                                        <Grid //Photoncount Input Field and Slider
                                            item
                                            xs
                                            sx={{ display: "flex", flexDirection: "column" }}>

                                            <Grid //Photoncount Input Field
                                                container
                                                spacing={0}
                                                alignItems="center">

                                                <Grid item>
                                                    <Typography variant="subtitle1" color="textPrimary" sx={{ fontWeight: 600 }}>
                                                        Photoncount:
                                                    </Typography>
                                                </Grid>

                                                <Grid item>
                                                    <Input
                                                        value={photonCount_Scale(this.state.photonCount)}
                                                        size="small"
                                                        onChange={(event) => {
                                                            this.setState({ photonCount: photonCount_RevScale(event.target.value) }); //When Changed: Changes Photoncount Slider Position
                                                        }}
                                                        inputProps={{
                                                            step: 10,
                                                            min: marks_Slider_PhotonCount[0].scaledValue,
                                                            max: marks_Slider_PhotonCount[marks_Slider_PhotonCount.length - 1].scaledValue,
                                                            type: 'number',
                                                        }}
                                                        sx={{ width: '90%', marginLeft: 1 }}
                                                    />
                                                </Grid>

                                            </Grid>

                                            <Slider //Photoncount Slider
                                                sx={{ display: "flex", marginLeft: 2, marginRight: 2, marginTop: 0.4, width: "88%" }}
                                                value={this.state.photonCount} //Pulls value from default or Photoncount input field
                                                min={0}
                                                step={1}
                                                max={100}
                                                marks={marks_Slider_PhotonCount} //Defined above
                                                scale={photonCount_Scale}
                                                onChange={(event, newValue) => {
                                                    this.setState({ photonCount: newValue });
                                                }}
                                            />

                                        </Grid>

                                    </Grid>


                                </Paper>

                            </Grid>

                            <Grid //Grid Group (Center): Orientation, Displacement, Rotationcount
                                item xs={4}
                                md={4}>

                                <Paper
                                    elevation={3}
                                    sx={{ flexGrow: 1, height: '100%', minWidth: 150 }}
                                    onMouseEnter={() => this.setState({ isHoverObject: true, isHoverDetector: false, isHoverSource: false, isHoverSDD: false })}
                                    onMouseLeave={() => this.setState({ isHoverObject: false, isHoverDetector: false, isHoverSource: false, isHoverSDD: false })}>

                                    <Grid
                                        container
                                        direction="column"
                                        justifyContent="flex-start"
                                        alignItems="stretch"
                                        sx={{ height: '100%', paddingLeft: 3, paddingRight: 1 }}
                                    >

                                        <Grid //Grid for Orientation Settings (Phi&Theta)
                                            item
                                            xs
                                            sx={{ display: "flex", flexDirection: "column", marginTop: 2 }}>

                                            <Typography variant="subtitle1" color="textPrimary" sx={{ fontWeight: 600 }}>
                                                Orientation [°]
                                            </Typography>

                                            <Grid //Text boxes for Phi and Theta
                                                container
                                                direction="row"
                                                alignItems="stretch"
                                                justifyContent="flex-start"
                                                sx={{ width: '100%', marginTop: 0.4 }}>

                                                <Grid item xs sx={{ display: "flex", flexDirection: "row" }}>
                                                    <Box sx={{ flexGrow: 1 }}>
                                                        <TextField
                                                            label="Phi"
                                                            style={{ minWidth: 120, maxWidth: 120 }}
                                                            variant="outlined"
                                                            value={this.state.orientationPhi}
                                                            size="small"
                                                            onChange={(event) => {
                                                                this.setState({ orientationPhi: event.target.value }); //Changes Phi Orientaiton for Simulation
                                                            }}
                                                            inputProps={{
                                                                step: 0.1,
                                                                min: 0,
                                                                max: 360,
                                                                type: 'number',
                                                            }}
                                                        />
                                                    </Box>
                                                </Grid>

                                                <Grid item xs sx={{ display: "flex", flexDirection: "row" }}>
                                                    <Box sx={{ flexGrow: 1 }}>
                                                        <TextField
                                                            label="Theta"
                                                            style={{ minWidth: 120, maxWidth: 120 }}
                                                            variant="outlined"
                                                            value={this.state.orientationTheta}
                                                            size="small"
                                                            onChange={(event) => {
                                                                this.setState({ orientationTheta: event.target.value }); //Changes Theta Orientaiton for Simulation
                                                            }}
                                                            inputProps={{
                                                                step: 0.1,
                                                                min: 0,
                                                                max: 360,
                                                                type: 'number',
                                                            }}
                                                        />
                                                    </Box>
                                                </Grid>

                                            </Grid>


                                        </Grid>


                                        <Grid //Grid for Displacement Settings in mm (xyz)
                                            item
                                            xs
                                            sx={{ display: "flex", flexDirection: "column", marginTop: 0 }}>

                                            <Typography variant="subtitle1" color="textPrimary" sx={{ fontWeight: 600 }}>
                                                Displacement [mm]
                                            </Typography>

                                            <Grid //Textfields for xyz
                                                container
                                                direction="row"
                                                alignItems="stretch"
                                                justifyContent="flex-start"
                                                spacing={0}
                                                sx={{ width: '100%' }}>

                                                <Grid //Textfield for X
                                                    item
                                                    xs
                                                    sx={{ display: "flex", flexDirection: "row", marginTop: 0.4 }}>
                                                    <Box sx={{ flexGrow: 1 }}>
                                                        <TextField
                                                            label="x"
                                                            style={{ minWidth: 78, maxWidth: 78 }}
                                                            variant="outlined"
                                                            value={this.state.displacementX}
                                                            size="small"
                                                            onChange={(event) => {
                                                                this.setState({ displacementX: event.target.value }); //Changes X Displacement for Simulation
                                                            }}
                                                            inputProps={{
                                                                step: 0.1,
                                                                min: 0,
                                                                max: 100,
                                                                type: 'number',
                                                            }}
                                                        />
                                                    </Box>
                                                </Grid>

                                                <Grid //Textfield for Y
                                                    item
                                                    xs
                                                    sx={{ display: "flex", flexDirection: "row", marginTop: 0.4 }}>
                                                    <Box sx={{ flexGrow: 1 }}>
                                                        <TextField
                                                            label="y"
                                                            style={{ minWidth: 78, maxWidth: 78 }}
                                                            variant="outlined"
                                                            value={this.state.displacementY}
                                                            size="small"
                                                            onChange={(event) => {
                                                                this.setState({ displacementY: event.target.value }); //Changes Y Displacement for Simulation
                                                            }}
                                                            inputProps={{
                                                                step: 0.1,
                                                                min: 0,
                                                                max: 100,
                                                                type: 'number',
                                                            }}
                                                        />
                                                    </Box>
                                                </Grid>

                                                <Grid //Textfield for Z
                                                    item
                                                    xs
                                                    sx={{ display: "flex", flexDirection: "row", marginTop: 0.4 }}>
                                                    <Box sx={{ flexGrow: 1 }}>
                                                        <TextField
                                                            label="z"
                                                            style={{ minWidth: 78, maxWidth: 78 }}
                                                            variant="outlined"
                                                            value={this.state.displacementZ}
                                                            size="small"
                                                            onChange={(event) => {
                                                                this.setState({ displacementZ: event.target.value }); //Changes Z Displacement for Simulation
                                                            }}
                                                            inputProps={{
                                                                step: 0.1,
                                                                min: 0,
                                                                max: 100,
                                                                type: 'number',
                                                            }}
                                                        />
                                                    </Box>
                                                </Grid>


                                            </Grid>


                                        </Grid>

                                        <Grid //Grid for Rotationcount field and slider
                                            item
                                            xs
                                            sx={{ display: "flex", flexDirection: "column" }}>

                                            <Grid container spacing={0} alignItems="center">

                                                <Grid item>
                                                    <Typography variant="subtitle1" color="textPrimary" sx={{ fontWeight: 600 }}>
                                                        Rotationcount:
                                                    </Typography>
                                                </Grid>

                                                <Grid item>
                                                    <Input //Rotationcount input field
                                                        value={rotationCount_Scale(this.state.rotationCount)}
                                                        size="small"
                                                        onChange={(event) => {
                                                            this.setState({ rotationCount: rotationCount_RevScale(event.target.value) }); //When changed: Changes slider position
                                                        }}
                                                        inputProps={{
                                                            step: 10,
                                                            min: marks_Slider_RotationCounts[0].scaledValue,
                                                            max: marks_Slider_RotationCounts[marks_Slider_RotationCounts.length - 1].scaledValue,
                                                            type: 'number',
                                                        }}
                                                        sx={{ width: '90%', marginLeft: 1 }}
                                                    />
                                                </Grid>

                                            </Grid>

                                            <Slider //Rotationcount Slider
                                                sx={{ display: "flex", marginLeft: 2, marginRight: 2, marginTop: 0.4, width: "82%" }}
                                                value={this.state.rotationCount} //Pulls Rotationcount from input field and displays it
                                                min={0}
                                                step={1}
                                                max={80}
                                                scale={rotationCount_Scale} //Scale and marks defined above
                                                marks={marks_Slider_RotationCounts}
                                                onChange={(event, newValue) => {
                                                    this.setState({ rotationCount: newValue }); //When changed: Changes input field value
                                                }}
                                            />

                                        </Grid>

                                    </Grid>



                                </Paper>

                            </Grid>

                            <Grid //Grid Group (right): Papers 3&4
                                item xs={4} md={4}>

                                <Grid
                                    container
                                    direction="column"
                                    alignItems="stretch"
                                    justifyContent="flex-start"
                                    spacing={0}
                                    sx={{ width: '100%', height: '100%', flexGrow: 1, minWidth: 200 }}>

                                    <Grid //Grid (upper right): Detector type & Resolution Slider
                                        item xs
                                        sx={{ display: "flex", flexDirection: "row", height: '40%' }}>
                                        <Box sx={{ flexGrow: 1 }}>
                                            <Paper elevation={3} sx={{ flexGrow: 1, height: '100%', minWidth: 200 }}
                                                onMouseEnter={() => this.setState({ isHoverDetector: true, isHoverObject: false, isHoverSource: false, isHoverSDD: false })}
                                                onMouseLeave={() => this.setState({ isHoverDetector: false, isHoverObject: false, isHoverSource: false, isHoverSDD: false })}>

                                                <Grid
                                                    container
                                                    direction="column"
                                                    justifyContent="flex-start"
                                                    alignItems="stretch"
                                                    sx={{ height: '100%', paddingLeft: 3, paddingRight: 3 }}
                                                >

                                                    <Grid //Dropdown list for Detector types
                                                        item
                                                        xs={3}
                                                        sx={{ display: "flex", flexDirection: "column" }}>

                                                        <FormControl size="small" sx={{ m: 2.5, width: '86%' }}>
                                                            <InputLabel>Detectortype</InputLabel>
                                                            <Select
                                                                value={this.state.detectorType}
                                                                label="Detectortype"
                                                                onChange={(event) => { this.setState({ detectorType: event.target.value }); }}>
                                                                {detectorTypes.map((label, index) => {
                                                                    return (<MenuItem value={label}>{label}</MenuItem>); //Changes detector type
                                                                })}
                                                            </Select>
                                                        </FormControl>

                                                    </Grid>

                                                    <Grid //Grid for Resolution Input field and slider
                                                        item
                                                        xs
                                                        sx={{ display: "flex", flexDirection: "column" }}>

                                                        <Grid container spacing={0} alignItems="center">

                                                            <Grid item>
                                                                <Typography variant="subtitle1" color="textPrimary" sx={{ fontWeight: 600 }}>
                                                                    Resolution:
                                                                </Typography>
                                                            </Grid>

                                                            <Grid item>
                                                                <Input //Input fields for detector resolution
                                                                    value={this.state.detectorResolution} //Pulls value from resolution slider
                                                                    size="small"
                                                                    onChange={(event) => {
                                                                        this.setState({ detectorResolution: event.target.value }); //When Changed: Changes resolution slider
                                                                    }}
                                                                    inputProps={{
                                                                        step: 10,
                                                                        min: 100,
                                                                        max: 2000,
                                                                        type: 'number',
                                                                    }}
                                                                    sx={{ width: '70%', marginLeft: 0 }}
                                                                />
                                                            </Grid>

                                                            <Grid //PPR Display; FOV defined above (Parameters: FOV&Resolution)
                                                                item>
                                                                <Typography variant="subtitle1" color="textPrimary" sx={{ fontWeight: 600, marginLeft: 0.5 }}>
                                                                    {FoV} (mm)
                                                                </Typography>
                                                            </Grid>

                                                        </Grid>

                                                        <Slider //Resolution Slider
                                                            sx={{ display: "flex", marginLeft: 2, marginRight: 2, marginTop: 0.4, width: "82%" }}
                                                            value={this.state.detectorResolution} //Pulls value from input fields or predefined value
                                                            min={100}
                                                            step={10}
                                                            max={2000}
                                                            marks={marks_Slider_DetectorRes}
                                                            onChange={(event, newValue) => {
                                                                this.setState({ detectorResolution: newValue }); //When Changed: Changes Resolution Input Field value
                                                            }}
                                                        />

                                                    </Grid>

                                                </Grid>



                                            </Paper>
                                        </Box>
                                    </Grid>

                                    <Grid //Grid (lower right): Simulation Parameters and start button
                                        item xs
                                        sx={{ display: "flex", flexDirection: "row", height: '56%', marginTop: 2 }}>
                                        <Box sx={{ flexGrow: 1 }}>
                                            <Paper elevation={3} sx={{ flexGrow: 1, height: '100%', minWidth: 300 }} >

                                                <Grid
                                                    container //Grid containing 2 Subgrids for 5 Parameters to be checked on/off
                                                    direction="row"
                                                    alignItems="stretch"
                                                    justifyContent="flex-start"
                                                    sx={{ width: '100%' }}>

                                                    <Grid item xs sx={{ display: "flex", flexDirection: "row", marginTop: 2, marginLeft: 3 }}>
                                                        <Box sx={{ flexGrow: 1 }}>
                                                            <FormGroup>
                                                                <FormControlLabel control={<Checkbox size="small" />} label="Projections" onChange={(event) => { this.setState({ optionProjection: event.target.checked }); }} />
                                                                <FormControlLabel control={<Checkbox size="small" />} label="Sinograms" onChange={(event) => { this.setState({ optionSinogram: event.target.checked }); }} />
                                                               
                                                            </FormGroup>
                                                        </Box>
                                                    </Grid>

                                                    <Grid item xs sx={{ display: "flex", flexDirection: "row", marginTop: 2, marginRight: 3 }}>
                                                        <Box sx={{ flexGrow: 1 }}>
                                                            <FormGroup>
                                                                <FormControlLabel control={<Checkbox size="small" />} label="Material mesh" onChange={(event) => { this.setState({ optionMaterialmesh: event.target.checked }); }} />
                                                                <FormControlLabel control={<Checkbox size="small" />} label="Q-factors" onChange={(event) => { this.setState({ optionQFactor: event.target.checked }); }} />
                                                            </FormGroup>
                                                        </Box>
                                                    </Grid>

                                                </Grid>

                                                <Button //Starts Simulation; this currently only creates a .json file and starts its download (to be changed)
                                                    variant="contained"
                                                    startIcon={<RUNIcon />}
                                                    sx={{ width: '86%', m: 2.5, "&:hover": { backgroundColor: "#04549c" } }}
                                                    onClick={() => {
                                                        this.props.onSubmitParmaterts([marks_Slider_ObjectPos.findIndex((mark) => mark.value === this.state.objectPosition).label, //Sets Parameters and Values for the Simulation
                                                        this.state.sdd,
                                                        this.state.xRaySourceType,
                                                        this.state.voltageMin,
                                                        this.state.voltageMax,
                                                        photonCount_Scale(this.state.photonCount),
                                                        this.state.orientationPhi,
                                                        this.state.orientationTheta,
                                                        this.state.displacementX,
                                                        this.state.displacementY,
                                                        this.state.displacementZ,
                                                        rotationCount_Scale(this.state.rotationCount),
                                                        this.state.detectorType,
                                                        this.state.optionProjection,
                                                        this.state.optionSinogram,
                                                        this.state.optionMaterialmesh,
                                                        this.state.optionQFactor,
                                                        this.state.optionPablo
                                                        ]);

                                                        downloadJSON();

                                                    }}
                                                >
                                                    Start simulation
                                                </Button>

                                            </Paper>
                                        </Box>
                                    </Grid>

                                </Grid>



                            </Grid>

                        </Grid>

                    </Box>

                </Grid>

                <Snackbar //If no parameters are selected, an alert is thrown to the user
                    open={this.state.showAlertSimulationStart}
                    autoHideDuration={10000}
                    onClose={() => { this.setState({ showAlertSimulationStart: false }); }}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>

                    <Alert
                        elevation={6}
                        variant="filled"
                        style={{ backgroundColor: '#073f8d' }}
                        onClose={() => { this.setState({ showAlertSimulationStart: false }); }}
                        severity="info">

                        Parameters missing!

                    </Alert>

                </Snackbar>

            </Grid>

        );

    }

}



//-----------------------------------------------------------------



const mapStateToProps = (state, props) => {

    return {
        objectPosition: state.interaction.objectPosition,
        stlBounds: state.stlColumn.stlBounds,
        stlObjects: state.stlColumn.STL_List_Items,
    };

}

const mapDispatchToProps = (dispatch, props) => {

    return {
        onSubmitParmaterts: (val) => { dispatch({ type: "CT-PARAMS:SUBMIT", value: val }) }
    };

}


const CT_Column = connect(mapStateToProps, mapDispatchToProps)(CT_Column_)
export default withStyles(useStyles)(CT_Column);
